export const mockPosts = {
  data: [
    {
      media_url:
        "https://scontent.cdninstagram.com/v/t51.29350-15/385804637_297115759738197_8439541040301058113_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=18de74&_nc_ohc=2lmkgkKMOpkAX94Y2wc&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AfA8EbYIEkwl0ptTRVLitO7wmu0zz1OSlgq3AM5Vg_Mewg&oe=6606EB69",
      media_type: "IMAGE",
      permalink: "https://www.instagram.com/p/Cx8TT9Mr0xM/",
      timestamp: "2023-10-03T15:46:58+0000",
      caption: "CONFIRA ❗️\n\nVolkswagen Virtus 1.4 250 Tsi Exclusive | 2023",
      id: "18311250391107835",
    },
    {
      media_url:
        "https://scontent.cdninstagram.com/v/t51.29350-15/385587349_149866491481131_8991467268480341435_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=18de74&_nc_ohc=G48yrXvbibIAX9DrUhx&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AfDpFFg264Nqg_2IrS5kJt07uIlfaT1_nDgNBhq8FHOTLw&oe=6606A7AF",
      media_type: "IMAGE",
      permalink: "https://www.instagram.com/p/Cx785RArSiE/",
      timestamp: "2023-10-03T12:31:05+0000",
      caption: "VENDIDO✅",
      id: "18010874080934286",
    },
    {
      media_url:
        "https://scontent.cdninstagram.com/v/t51.29350-15/382559681_286060044219829_5936875035226562719_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=18de74&_nc_ohc=6LlCtY6DkjEAX9lu28b&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AfBPrzTtV76Si9eXng6_AjY5D-x4yOLbnv4eMDTjqwelyA&oe=66069932",
      media_type: "IMAGE",
      permalink: "https://www.instagram.com/p/CxyOzp1rXd8/",
      timestamp: "2023-09-29T17:55:12+0000",
      caption: "VENDIDO ✅",
      id: "17952444677680820",
    },
    {
      media_url:
        "https://scontent.cdninstagram.com/v/t51.29350-15/385804637_297115759738197_8439541040301058113_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=18de74&_nc_ohc=2lmkgkKMOpkAX94Y2wc&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AfA8EbYIEkwl0ptTRVLitO7wmu0zz1OSlgq3AM5Vg_Mewg&oe=6606EB69",
      media_type: "IMAGE",
      permalink: "https://www.instagram.com/p/Cx8TT9Mr0xM/",
      timestamp: "2023-10-03T15:46:58+0000",
      caption: "CONFIRA ❗️\n\nVolkswagen Virtus 1.4 250 Tsi Exclusive | 2023",
      id: "18311250391107835",
    },
    {
      media_url:
        "https://scontent.cdninstagram.com/v/t51.29350-15/385587349_149866491481131_8991467268480341435_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=18de74&_nc_ohc=G48yrXvbibIAX9DrUhx&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AfDpFFg264Nqg_2IrS5kJt07uIlfaT1_nDgNBhq8FHOTLw&oe=6606A7AF",
      media_type: "IMAGE",
      permalink: "https://www.instagram.com/p/Cx785RArSiE/",
      timestamp: "2023-10-03T12:31:05+0000",
      caption: "VENDIDO✅",
      id: "18010874080934286",
    },
    {
      media_url:
        "https://scontent.cdninstagram.com/v/t51.29350-15/382559681_286060044219829_5936875035226562719_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=18de74&_nc_ohc=6LlCtY6DkjEAX9lu28b&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AfBPrzTtV76Si9eXng6_AjY5D-x4yOLbnv4eMDTjqwelyA&oe=66069932",
      media_type: "IMAGE",
      permalink: "https://www.instagram.com/p/CxyOzp1rXd8/",
      timestamp: "2023-09-29T17:55:12+0000",
      caption: "VENDIDO ✅",
      id: "17952444677680820",
    },
    {
      media_url:
        "https://scontent.cdninstagram.com/v/t51.29350-15/385804637_297115759738197_8439541040301058113_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=18de74&_nc_ohc=2lmkgkKMOpkAX94Y2wc&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AfA8EbYIEkwl0ptTRVLitO7wmu0zz1OSlgq3AM5Vg_Mewg&oe=6606EB69",
      media_type: "IMAGE",
      permalink: "https://www.instagram.com/p/Cx8TT9Mr0xM/",
      timestamp: "2023-10-03T15:46:58+0000",
      caption: "CONFIRA ❗️\n\nVolkswagen Virtus 1.4 250 Tsi Exclusive | 2023",
      id: "18311250391107835",
    },
    {
      media_url:
        "https://scontent.cdninstagram.com/v/t51.29350-15/385587349_149866491481131_8991467268480341435_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=18de74&_nc_ohc=G48yrXvbibIAX9DrUhx&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AfDpFFg264Nqg_2IrS5kJt07uIlfaT1_nDgNBhq8FHOTLw&oe=6606A7AF",
      media_type: "IMAGE",
      permalink: "https://www.instagram.com/p/Cx785RArSiE/",
      timestamp: "2023-10-03T12:31:05+0000",
      caption: "VENDIDO✅",
      id: "18010874080934286",
    },
    {
      media_url:
        "https://scontent.cdninstagram.com/v/t51.29350-15/382559681_286060044219829_5936875035226562719_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=18de74&_nc_ohc=6LlCtY6DkjEAX9lu28b&_nc_ht=scontent.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AfBPrzTtV76Si9eXng6_AjY5D-x4yOLbnv4eMDTjqwelyA&oe=66069932",
      media_type: "IMAGE",
      permalink: "https://www.instagram.com/p/CxyOzp1rXd8/",
      timestamp: "2023-09-29T17:55:12+0000",
      caption: "VENDIDO ✅",
      id: "17952444677680820",
    },
  ],
  paging: {
    cursors: {
      before:
        "QVFIUjhiUWJ5anZAaUVpVU0M4OVJHLUZAsMnBQSERuSmh0NU1kaFpVdWFRZAXJkRTNMWEJOQnFiWmNQLUs2d183MUpOUzRzZA21wUlR4a18wZAHc1UHhRRmNndFN3",
      after:
        "QVFIUmJRWGRNbU5pZAmZAxRnE1TEJfUVVjekpkNUlNTVpEb044eDlrS1JOX2k1cmxydEc5Qm9GTzRQWnNnVkpDcDNSRDR4X3psSHdJWVZA1cy0yRDZAFTVhVcUN3",
    },
  },
};
